import { Box, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { getComp } from 'src/utils/utils/DI'
import { observer } from 'mobx-react'

const AppbarUserInfo = () => {
  const intl = useIntl()
  const name = getComp('UserInfoStore').userName
  const roles = getComp('UserInfoStore').roles?.join(', ')

  const getRoleToShow = () => {
    switch (true) {
      case roles.includes('superadmin'):
        return intl.formatMessage({ id: 'Администратор' })
      case roles.includes('manager'):
        return intl.formatMessage({ id: 'Сотрудник офиса' })
      case roles.includes('dealer'):
        return intl.formatMessage({ id: 'Дилер' })
      case roles.includes('callcenter'):
        return intl.formatMessage({ id: 'Оператор' })
      case roles.includes('looker'):
        return intl.formatMessage({ id: 'Наблюдатель' })
      case roles.includes('administration'):
        return intl.formatMessage({ id: 'Администрация' })
      case roles.includes('installer'):
        return intl.formatMessage({ id: 'Установщик' })
      default:
        return null
    }
  }
  return (
    <Box>
      <Typography
        sx={{
          fontSize: '10px',
          fontWeight: '400',
          lineHeight: '10px',
          textTransform: 'uppercase',
        }}
      >
        {getRoleToShow()}
      </Typography>
      <Typography
        sx={{ fontSize: '14px', fontWeight: '700', lineHeight: '15px' }}
      >
        {name}
      </Typography>
    </Box>
  )
}

export default observer(AppbarUserInfo)
